import { type Action, type ThunkDispatch } from '@reduxjs/toolkit';

import { type CryptoPaymentData } from '@app/client/common/structs/orders/cart';

import { type RootState } from '../reducers';
import { SET_PAYMENT_METHODS, SET_PURCHASED_AMOUNT } from '../types/crypto';

export function setCryptoPaymentData(methods: CryptoPaymentData[]) {
    return (dispatch: ThunkDispatch<RootState, void, Action>) => {
        dispatch({
            type: SET_PAYMENT_METHODS,
            payload: methods,
        });
    };
}

export function setPurchasedAmount(amount: { actualAmount: number; amount: number }) {
    return (dispatch: ThunkDispatch<RootState, void, Action>) => {
        dispatch({
            type: SET_PURCHASED_AMOUNT,
            payload: amount,
        });
    };
}
